import React from "react";
import { Button, Modal, Input } from "antd";
import { useState } from "react";
import CurrentClients from "./Vendors/CurrentVendors";
import { useConnectionProvider } from "../../../Providers/Vendor/Connections";
import Swal from "sweetalert2";
import { CheckEmailExist } from "../../Auth/Helper";
import { roles, userPermissions } from "../../../Utils/constants";
import { useSelector } from "react-redux";
export default function Vendors() {
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [emailUsed, setEmailUsed] = useState(false);
  const [filledEmail, setFilledEmail] = useState();
  const permissions = useSelector((state) => state.user.permissions);
  const InviteUserDefault = {
    invitedBy: localStorage.getItem("userId"),
    name: "",
    email: "",
    role: roles.vendor,
  };
  const [inviteUser, setInviteUser] = useState(InviteUserDefault);

  const checkEmailUsed = (email) => {
    CheckEmailExist({ email: email }).then((res) => {
      setFilledEmail(email);
      setEmailUsed(res?.data?.status);
      handleRequestChange(res?.data?.username, "username");
      handleRequestChange(email, "email");
    });
  };

  const [requestUser, setRequestUser] = useState({ email: "", username: "" });
  const handleInviteChange = (e, name) => {
    setInviteUser({
      ...inviteUser,
      id: localStorage.getItem("userId"),
      [name]: e.target.value,
    });
  };

  const handleRequestChange = (e, name) => {
    if (name === "email") {
      // console.log(e.target.value, filledEmail)
    }
    setRequestUser({
      ...requestUser,
      [name]: e?.target?.value || e,
    });
  };

  const { sendRequestToVendor, inviteNewUser } = useConnectionProvider();
  const inviteVendor = async () => {
    if (!emailUsed) {
      const res = await inviteNewUser(inviteUser);
      if (res) setOpen(false);
    } else {
      if (!requestUser?.email) {
        requestUser.email = filledEmail;
      }
      const res = await sendRequestToVendor(requestUser);
      if (res) setOpen(false);
    }
    setInviteUser(InviteUserDefault);
    setRequestUser({ email: "", username: "" });
  };
  const showModal = () => {
    setOpen(true);
  };
  const handleOk = () => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
      setOpen(false);
    }, 3000);
  };
  const handleCancel = () => {
    setOpen(false);
  };

  return (
    <div>
      <div className="flex justify-end -mt-4">
        {permissions?.includes(`admin-client`) ||
        permissions?.includes(userPermissions.vendorConnection.add) ? (
          <Button
            onClick={showModal}
            style={{
              width: "197px",
              height: "40px",
              background: "#139588",
              borderRadius: "5px",
              color: "white",
            }}
          >
            Add Vendors
          </Button>
        ) : null}
      </div>
      <Modal
        open={open}
        title="Add Vendor"
        onOk={handleOk}
        onCancel={handleCancel}
        footer={[
          <Button
            key="link"
            loading={loading}
            onClick={() => inviteVendor()}
            style={{
              width: "197px",
              height: "40px",
              background: "#139588",
              borderRadius: "5px",
              color: "white",
            }}
          >
            Invite Vendor
          </Button>,
        ]}
      >
        <div
          style={{
            background: "rgba(19, 149, 136, 0.2)",
            borderRadius: "16px",
          }}
          className="mt-4 p-4"
        >
          <div className="flex flex-col mt-2">
            <span className="mb-2 text-gray-700">Name</span>
            <Input
              className="w-92"
              placeholder="Enter Name"
              onChange={(e) => {
                handleInviteChange(e, "name");
              }}
              required
            />
          </div>
          <div className="flex flex-col">
            <span className="my-2 text-gray-700">
              Email <sup className="text-red-500">*</sup>
            </span>
            <Input
              className="w-92"
              placeholder="Enter Email"
              onChange={(e) => {
                checkEmailUsed(e.target.value);
                setFilledEmail(e.target.value);
                if (emailUsed) {
                  handleRequestChange(e, "email");
                } else {
                  handleInviteChange(e, "email");
                }
              }}
              required
            />
          </div>
          <div className="flex flex-col mt-2">
            <span className="mb-2 text-gray-700">Username</span>
            <Input
              className="w-92"
              placeholder="Enter Username"
              onChange={(e) => {
                handleRequestChange(e, "username");
              }}
              required
            />
          </div>
        </div>
      </Modal>
      <CurrentClients />
    </div>
  );
}
